import { remove_user_and_jwt } from "./users";


function Logout(){

    remove_user_and_jwt()
}

export default Logout